import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d351b3e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/main.css?vue&type=style&index=0&id=6d351b3e&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=6d351b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d351b3e",
  null
  
)

export default component.exports